import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/about/thumb.png';
import _imports_1 from '@/assets/about/img.png';
import _imports_2 from '@/assets/about/plat.png';

const _withScopeId = n => (_pushScopeId("data-v-0e22a7ac"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "about-us-wrapper"
};
const _hoisted_2 = {
  class: "about-header"
};
const _hoisted_3 = {
  class: "about-content-inner"
};
const _hoisted_4 = {
  class: "section-1"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "thumb"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));

const _hoisted_6 = {
  class: "desc"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));

const _hoisted_8 = {
  class: "section-2"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.bayanat.ai",
  target: "_blank",
  rel: "noopener noreferrer"
}, " www.bayanat.ai ", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-3"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
})], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_title = _resolveComponent("main-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_main_title, {
    size: 46,
    align: "left",
    name: _ctx.$tm('about.pageTitle')
  }, null, 8, ["name"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("dl", _hoisted_4, [_createElementVNode("dd", null, [_hoisted_5, _createVNode(_component_main_title, {
    align: "left",
    name: _ctx.$tm('about.contentTitle')
  }, null, 8, ["name"]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tm('about.desc')), 1)]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$tm('about.intactDesc')) + " ", 1), _hoisted_9]), _hoisted_10])]);
}